import { useEffect } from 'react';

interface UseEmployeesViewportEffectsProps {
  viewportNode: HTMLDivElement | null;
  maxScrollLeft: number;
  scrollLeft: number;
  setViewportWidth: (width: number) => void;
  setScrollLeft: (value: number) => void;
}

export const useEmployeesViewportEffects = ({
  viewportNode,
  maxScrollLeft,
  scrollLeft,
  setViewportWidth,
  setScrollLeft,
}: UseEmployeesViewportEffectsProps) => {
  useEffect(() => {
    if (!viewportNode) {
      return;
    }

    const observer = new ResizeObserver(([entry]) => {
      setViewportWidth(entry.contentRect.width);
    });

    observer.observe(viewportNode);
    setViewportWidth(viewportNode.clientWidth);

    return () => {
      observer.disconnect();
    };
  }, [viewportNode, setViewportWidth]);

  useEffect(() => {
    if (scrollLeft > maxScrollLeft) {
      setScrollLeft(maxScrollLeft);
    }
  }, [maxScrollLeft, scrollLeft, setScrollLeft]);
};
